import axios, { AxiosResponse, InternalAxiosRequestConfig } from 'axios'
// import { getCookie } from '@utils'
import { ENV } from './env'

export const instance = axios.create({
  baseURL: ENV.API_URL,
})

async function authorizationInterceptor(config: InternalAxiosRequestConfig) {
  // config.headers.Authorization = `Bearer ${getCookie('jwt')}`
  return config
}

async function responseInterceptor(response: AxiosResponse) {
  return response
}

async function errorInterceptor(error: any) {
  console.log('error:', error)
  return Promise.reject(error)
}

instance.interceptors.request.use(authorizationInterceptor)
instance.interceptors.response.use(responseInterceptor, errorInterceptor)
